import React, { useState } from 'react'

import Header from '../Core/Header'
import { patient } from '../../Assets/dummyPatient'
import { motion } from 'motion/react'

const fileData=[
  {
    doc:"Dr.Ramendra Trivedi",
    date:"2025-09-16",
  },
  {
    doc:"Dr.Ramendra Trivedi",
    date:"2025-09-16",
  },{
    doc:"Dr.Ramendra Trivedi",
    date:"2025-09-16",
  },{
    doc:"Dr.Ramendra Trivedi",
    date:"2025-09-16",
  },{
    doc:"Dr.Ramendra Trivedi",
    date:"2025-09-16",
  },{
    doc:"Dr.Ramendra Trivedi",
    date:"2025-09-16",
  },{
    doc:"Dr.Ramendra Trivedi",
    date:"2025-09-16",
  },{
    doc:"Dr.Ramendra Trivedi",
    date:"2025-09-16",
  },{
    doc:"Dr.Ramendra Trivedi",
    date:"2025-09-16",
  },{
    doc:"Dr.Ramendra Trivedi",
    date:"2025-09-16",
  },{
    doc:"Dr.Ramendra Trivedi",
    date:"2025-09-16",
  },{
    doc:"Dr.Ramendra Trivedi",
    date:"2025-09-16",
  },{
    doc:"Dr.Ramendra Trivedi",
    date:"2025-09-16",
  },{
    doc:"Dr.Ramendra Trivedi",
    date:"2025-09-16",
  },{
    doc:"Dr.Ramendra Trivedi",
    date:"2025-09-16",
  },{
    doc:"Dr.Ramendra Trivedi",
    date:"2025-09-16",
  },{
    doc:"Dr.Ramendra Trivedi",
    date:"2025-09-16",
  },{
    doc:"Dr.Ramendra Trivedi",
    date:"2025-09-16",
  },{
    doc:"Dr.Ramendra Trivedi",
    date:"2025-09-16",
  },{
    doc:"Dr.Ramendra Trivedi",
    date:"2025-09-16",
  },{
    doc:"Dr.Ramendra Trivedi",
    date:"2025-09-16",
  },{
    doc:"Dr.Ramendra Trivedi",
    date:"2025-09-16",
  },{
    doc:"Dr.Ramendra Trivedi",
    date:"2025-09-16",
  },{
    doc:"Dr.Ramendra Trivedi",
    date:"2025-09-16",
  },{
    doc:"Dr.Ramendra Trivedi",
    date:"2025-09-16",
  },{
    doc:"Dr.Ramendra Trivedi",
    date:"2025-09-16",
  },{
    doc:"Dr.Ramendra Trivedi",
    date:"2025-09-16",
  },{
    doc:"Dr.Ramendra Trivedi",
    date:"2025-09-16",
  },{
    doc:"Dr.Ramendra Trivedi",
    date:"2025-09-16",
  },{
    doc:"Dr.Ramendra Trivedi",
    date:"2025-09-16",
  },
]

const Patient = () => {
  const[list,setList]=useState(patient)
  const[verified,setVerified]=useState(false)
  let item1={
     name:"Subodh Roy",
        Age:45,
        Address:"123, Abc Road ,Kalyani,Nadia",
        AssignedDoc:["Dr. Albert Einstein","Dr. Issac Newton"],
        registered:'01-06-2020',
        disease:["Fever","Cancer","Thyroids"]
  }
  const [modal,setModal]=useState(false)
  return (
    <div style={{height:"100vh",width:"100%"}}>
      <Header/>
      <section style={{marginTop:"80px",height:"calc(100vh - 80px)",background: "linear-gradient(180deg, #555454ff, #ffffffff, #5f5f5fff)",padding:"20px",
        transition: "0.3s ease",filter: modal ? "blur(8px)" : "none", pointerEvents: modal ? "none" : "auto",
      }}>
        <div style={{fontSize:"24px",fontWeight:"700",textAlign:"center",display:"flex",justifyContent:"space-around",padding:"6px"}}>
            <p style={{color:"white"}}>All Patients of this Hospital</p>
            <input placeholder='Search Patient '
            style={{border:"0.5px solid white",
                borderRadius:"8px",
                fontSize:"16px",padding:"5px",
                backgroundColor:"white"
            }}/>
            </div>
        <div style={{height:"calc(100vh - 100px)",display:"flex",flexWrap:"wrap",width:"100%",overflowY:"auto",overflowX:"hidden"}}>
            {
            list.map((item)=>(
                <div style={{width:"22vw",minHeight:"40vh",maxHeight:"fit-content",borderRadius:"10px",padding:"10px",backgroundColor:"#c5c4c4ff",
                    display:"flex",flexDirection:"column",alignItems:"center",margin:"10px",position:"relative"
                }}>
                    <img src='/Assets/patient.webp' style={{height:"70%",width:"85%",borderRadius:"10px"}}/>
                    <div style={{display:"flex",flexDirection:"column",alignItems:"start",width:"90%"}}>
                        <p style={{fontSize:"20px",textAlign:"left",fontWeight:"500"}}>{item.name}</p>
                        <p style={{width:"100%",display:"flex",justifyContent:"space-between"}}>
                            <span style={{fontSize:'14px',fontWeight:"700",color:"#d65d3eff"}}>Age:{item.Age}</span>
                            <span style={{fontSize:'14px',fontWeight:"700",color:"#6fa0d8ff"}}>Reg:{item.registered}</span></p>
                        <p style={{width:"100%",display:"flex",justifyContent:"space-between"}}>
                            <span style={{fontSize:'16px',fontWeight:"700",color:"#a3343aff"}}>{item.Address}</span>
                            </p>
                        <p style={{fontSize:"14px",fontWeight:"800"}}>Assigned Doctors</p>
                        <div style={{width:"100%",display:"flex",alignItems:"center",gap:"10px",flexWrap:"wrap"}}>
                            
                            {
                            item.AssignedDoc.map(i=>
                            <p style={{fontSize:"14px",padding:"3px",borderRadius:"8px",backgroundColor:"#041c3bff",color:"white"}}>{i}</p>)
                        }</div>
                      <p style={{fontSize:"14px",fontWeight:"800"}}>Diseases:</p>
                         <div style={{width:"100%",display:"flex",alignItems:"center",gap:"10px",flexWrap:"wrap"}}>
                            
                            {
                            item.disease.map(i=>
                            <p style={{fontSize:"14px",padding:"3px",borderRadius:"8px",backgroundColor:"#053d2cff",color:"#fcfcfcff"}}>{i}</p>)
                        }</div>
                     </div>

                     <div onClick={()=>setModal(true)}
                     style={{display:"flex",alignItems:"center",padding:"3px",borderRadius:"10px",backgroundColor:"#fdecb3ff",
                      position:"absolute",top:"1px",right:"1px",cursor:"pointer"
                     }}>
                      <img src='/Assets/data.png' style={{width:"30px"}}/>
                      <p style={{fontSize:"18px",fontWeight:"700"}}>Track data</p>
                     </div>

                    </div>
            ))
            }

        </div>

      </section>
      {
        modal && 
        <motion.div 
        initial={{y:150,opacity:1}}
        animate={{y:0,opacity:1}}
        transition={{
          duration:1.3
        }}
        style={{
          height:"90vh",width:"100%",backgroundColor:"white",
          position:"absolute",zIndex:999,top:"200px",padding:"20px",borderRadius:"10px"
        }}
        >
          <div style={{width:"100%",height:"60px",display:"flex",alignItems:"center",justifyContent:"left",gap:"30px",padding:'20px',borderBottom:'1px solid gray',fontSize:'18px',fontWeight:700,cursor:"pointer"}}>
          <p onClick={()=>setModal(false)}>X</p>
          {
          !verified?
          <div style={{display:"flex",alignItems:"center",justifyContent:"left",gap:"20px",padding:"2px 20px",backgroundColor:"#fccfb0ff",borderRadius:"6px"}}>
            <p>Otp sent to patient's email</p>
            <input style={{border:"1px solid gray",borderRadius:"5px",outline:"none",fontSize:"12px",padding:"6px"}}
            placeholder='Enter OTP'/>
            <p onClick={()=>setVerified(true)}
            style={{cursor:"pointer",padding:"7px",borderRadius:"5px",backgroundColor:"#5b8fffff",fontSize:"12px",fontWeight:"700",color:"white"}}>verify</p>
          </div>
          :
          <p >Tracking data of patient</p>
          }
          
          </div>
          
          <div style={{height:"calc(90vh-60px)",width:"100%",backgroundColor:"#eeeeeeff",minHeight:"calc(90vh-60px)",maxHeight:"calc(90vh-60px)",
            display:"flex",alignItems:"start",justifyContent:"left", transition: "0.3s ease",filter: !verified ? "blur(8px)" : "none", pointerEvents: !verified ? "none" : "auto",
          }}>
             <div style={{width:"22vw",minHeight:"40vh",maxHeight:"fit-content",borderRadius:"10px",padding:"10px",backgroundColor:"#c5c4c4ff",
                    display:"flex",flexDirection:"column",alignItems:"center",margin:"10px",position:"relative"
                }}>
                    <img src='/Assets/patient.webp' style={{height:"70%",width:"85%",borderRadius:"10px"}}/>
                    <div style={{display:"flex",flexDirection:"column",alignItems:"start",width:"90%"}}>
                        <p style={{fontSize:"20px",textAlign:"left",fontWeight:"500"}}>{item1.name}</p>
                        <p style={{width:"100%",display:"flex",justifyContent:"space-between"}}>
                            <span style={{fontSize:'14px',fontWeight:"700",color:"#d65d3eff"}}>Age:{item1.Age}</span>
                            <span style={{fontSize:'14px',fontWeight:"700",color:"#6fa0d8ff"}}>Reg:{item1.registered}</span></p>
                        <p style={{width:"100%",display:"flex",justifyContent:"space-between"}}>
                            <span style={{fontSize:'16px',fontWeight:"700",color:"#a3343aff"}}>{item1.Address}</span>
                            </p>
                        <p style={{fontSize:"14px",fontWeight:"800"}}>Assigned Doctors</p>
                        <div style={{width:"100%",display:"flex",alignItems:"center",gap:"10px",flexWrap:"wrap"}}>
                            
                            {
                            item1.AssignedDoc.map(i=>
                            <p style={{fontSize:"14px",padding:"3px",borderRadius:"8px",backgroundColor:"#041c3bff",color:"white"}}>{i}</p>)
                        }</div>
                      <p style={{fontSize:"14px",fontWeight:"800"}}>Diseases:</p>
                         <div style={{width:"100%",display:"flex",alignItems:"center",gap:"10px",flexWrap:"wrap"}}>
                            
                            {
                            item1.disease.map(i=>
                            <p style={{fontSize:"14px",padding:"3px",borderRadius:"8px",backgroundColor:"#053d2cff",color:"#fcfcfcff"}}>{i}</p>)
                        }</div>
                     </div>

                    

                    </div>
            <div style={{width:"70%"}}>
              <div style={{display:"flex",alignItems:"center",justifyContent:"left",gap:"30px",padding:"20px"}}>
                <label style={{fontSize:"15px",fontWeight:"700"}}>Upload new Prescription</label>
                <input type='file'style={{backgroundColor:"#afaeaeff",borderRadius:"6px",padding:"4px"}}/>

              </div>
              <div style={{display:"flex",alignItems:"center",flexWrap:"wrap",maxHeight:"50vh",height:"50vh",overflowY:"auto"}}>
                        {
                          fileData.map((file)=>(
                            <div style={{padding:"10px",borderRadius:"10px",backgroundColor:"#bbe3fdff",margin:"6px"}}>
                              <img src='/Assets/doc-data.png' style={{width:"180px",height:"220px"}}/>
                              <p style={{fontSize:"13px",fontWeight:"700"}}>Doctor :{file.doc}</p>
                              <p style={{fontSize:"12px",fontWeight:"700"}}>Date:{file.date}</p>
                              </div>
                          ))
                        }

              </div>

            </div>

          </div>

          </motion.div>
      }


    </div>
  )
}

export default Patient
